
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"baseProfile":"basic","xmlns":"http://www.w3.org/2000/svg","viewBox":"44 44 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#356ae6"}},[_c('path',{attrs:{"d":"M146.6 150.7c2.6 0 5.2-1 8-3.1 3.3-2.3 6.2-4.2 6.2-4.2l1-.7-1-.7c-.4-.3-43.9-30.5-48.4-33.4-2.1-1.5-4.5-1.8-6.4-.9-1.8.9-2.8 2.8-2.8 5.1v10.3l.4.2c.3.2 30.2 21 36 24.9 2.4 1.7 4.7 2.5 7 2.5z"}}),_c('path',{attrs:{"d":"M204.9 132.6c-2.6-1.9-95.9-67-99.9-69.8l-1.3-.9v16c0 5.1 2.7 7 6 9.4 0 0 71.6 49.9 80.5 56-8.9 6.2-76.3 52.9-80.6 55.6-5.1 3.4-5.6 5.6-5.6 10.2v17.2s98.7-70.6 100.8-72.2c4.5-3.4 5.5-7.4 5.6-10.3V142c.1-3.6-1.8-6.8-5.5-9.4z"}})])])
          )
        }
      }
    